// Hook for syncing Ory session on app initialization
import { useEffect, useRef } from 'react';
import { useAuthStore } from '@store';

/**
 * Custom hook to sync Ory session on app load
 * This hook should be called at the root level of the application
 * It checks for active Ory sessions and falls back to legacy auth if needed
 */
export const useOrySession = () => {
  const syncOrySession = useAuthStore((state) => state.syncOrySession);
  const hasInitialized = useRef(false);

  useEffect(() => {
    // Only run once on mount
    if (!hasInitialized.current) {
      hasInitialized.current = true;

      // Sync session on app load
      syncOrySession();
    }
  }, [syncOrySession]);
};
